import React, { useEffect, useState } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  FilterRow,
  Pager,
  Paging,
  SearchPanel,
  ColumnChooser,
  Editing,
  FormItem,
  Position,
  Popup,
  Form,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/form";
import "devextreme-react/text-area";
import LoadPanel from "devextreme-react/load-panel";
import { useAuth } from "../../contexts/auth";
import useFetchParameters from "../../hooks/useFetchParameters";
import notify from "devextreme/ui/notify";
import "./Parameters.scss";
import { requestERPLYData } from "../../utils/requestERPLY";
import { partnerKey } from "../../utils";

export default () => {
  const [allowEdit, setAllowEdit] = useState(false);
  const { parameters, isLoading, fetchParameters } = useFetchParameters();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      fetchParameters(
        {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        },
        user.isIframe
      );
    }
  }, [user]);

  const onInitNewRow = () => {
    setAllowEdit(true);
  };

  const onEditCanceled = () => {
    setAllowEdit(false);
  };

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;

    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "addRowButton") {
        item.options.hint = "Add new parameter";
        item.options.text = "Add new parameter";
      }

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };

  const onRowUpdating = async (e) => {
    const {
      key,
      newData: { value },
    } = e;

    let request;

    if (user.isIframe) {
      request = {
        parameterName: key,
        parameterValue: value,
        sessionKey: user.sessionKey,
        clientCode: user.clientCode,
        request: "saveConfParameter",
        partnerKey,
      };
    } else {
      request = {
        parameterName: key,
        parameterValue: value,
        clientCode: user.clientCode,
        request: "saveConfParameter",
        partnerKey,
      };
    }

    try {
      const { data } = await requestERPLYData(request);
      if (data.status.responseStatus === "ok") {
        notify(`Parameter value updated successfully`, "success", 3000);
      } else {
        if (data.status.errorCode === 1016) {
          notify(
            `Invalid value. (Attribute "errorField" indicates the field that contains an invalid value.)`,
            "error",
            3000
          );
          fetchParameters(
            {
              clientCode: user.clientCode,
              sessionKey: user.sessionKey,
            },
            user.isIframe
          );
        } else {
          notify(`Error updating parameter value`, "error", 3000);
          fetchParameters(
            {
              clientCode: user.clientCode,
              sessionKey: user.sessionKey,
            },
            user.isIframe
          );
        }
      }
    } catch (error) {
      notify(`Error updating parameter value`, "error", 3000);
      fetchParameters(
        {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        },
        user.isIframe
      );
    }
  };

  const onRowInserting = async (e) => {
    const {
      data: { name, value },
    } = e;

    let request;

    if (user.isIframe) {
      request = {
        parameterName: name,
        parameterValue: value,
        sessionKey: user.sessionKey,
        clientCode: user.clientCode,
        request: "saveConfParameter",
        partnerKey,
      };
    } else {
      request = {
        parameterName: name,
        parameterValue: value,
        clientCode: user.clientCode,
        request: "saveConfParameter",
        partnerKey,
      };
    }

    setAllowEdit(false);

    try {
      const { data } = await requestERPLYData(request);
      if (data.status.responseStatus === "ok") {
        notify(`Parameter added successfully`, "success", 3000);
      } else {
        if (data.status.errorCode === 1016) {
          notify(
            `Invalid value. (Attribute "errorField" indicates the field that contains an invalid value.)`,
            "error",
            3000
          );
          fetchParameters(
            {
              clientCode: user.clientCode,
              sessionKey: user.sessionKey,
            },
            user.isIframe
          );
        } else {
          notify(`Error adding parameter`, "error", 3000);
          fetchParameters(
            {
              clientCode: user.clientCode,
              sessionKey: user.sessionKey,
            },
            user.isIframe
          );
        }
      }
    } catch (error) {
      notify(`Error updating parameter value`, "error", 3000);
      fetchParameters(
        {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        },
        user.isIframe
      );
    }
  };

  return (
    <React.Fragment>
      <h2 className={"content-block"}>Parameters</h2>
      <div className={"content-block"}>
        {isLoading ? (
          <LoadPanel visible={true} />
        ) : (
          <React.Fragment>
            <DataGrid
              dataSource={parameters}
              keyExpr="name"
              showBorders={true}
              showRowLines={true}
              showColumnLines={true}
              allowColumnReordering={true}
              allowColumnResizing={true}
              rowAlternationEnabled={true}
              hoverStateEnabled={true}
              wordWrapEnabled={false}
              onToolbarPreparing={onToolbarPreparing}
              onInitNewRow={onInitNewRow}
              onEditCanceled={onEditCanceled}
              onRowUpdating={onRowUpdating}
              onRowInserting={onRowInserting}
            >
              <SearchPanel
                visible={true}
                width={300}
                searchVisibleColumnsOnly={true}
              />
              <ColumnChooser enabled={false} mode="select" allowSearch={true} />

              <Paging defaultPageSize={50} />
              <HeaderFilter allowSearch={true} visible={true} />
              <Editing
                mode="form"
                allowAdding={true}
                allowUpdating={true}
                allowDeleting={false}
              >
                {/* <Popup
                  title="Configuration Parameters"
                  showTitle={true}
                  width={700}
                  height="auto"
                ></Popup>
                <Form>
                  <Item itemType="group" colCount={2} colSpan={2}>
                    <Item dataField="name" colSpan={2} />
                  </Item>

                  <Item itemType="group" colCount={2} colSpan={2}>
                    <Item
                      dataField="value"
                      editorType="dxTextArea"
                      colSpan={2}
                      editorOptions={{
                        autoResizeEnabled: true,
                      }}
                    />
                  </Item>
                </Form> */}
              </Editing>

              <FilterRow visible={true} applyFilter="auto" />

              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[50, 100, 200]}
                showNavigationButtons={true}
                showInfo={true}
              />

              <Column
                caption="Name"
                dataField="name"
                allowEditing={allowEdit}
              />
              <Column caption="Value" dataField="value">
                <FormItem
                  colSpan={2}
                  editorType="dxTextArea"
                  editorOptions={{ autoResizeEnabled: true }}
                />
              </Column>
            </DataGrid>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
